import React from "react";
import banco from "../../../imagenes/checkout/payment-options/deposito.png";
import banco2x from "../../../imagenes/checkout/payment-options/deposito@2x.png";
import TextoLeyPais from "./textoLeyPais";

const CuadroDeposito = ({
  codigoMoneda,
  esNacional,
  idMedioDePago,
  onMedioDePagoChange,
}) => {
  return (
    <li className="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12">
      <div className="payment-card">
        <div className="md-radio">
          <input
            type="radio"
            id="deposito"
            checked={idMedioDePago === "2"}
            name="medioDePago"
            onChange={onMedioDePagoChange}
            value="2"
          />
          <label htmlFor="deposito">&nbsp;</label>
        </div>
        <h6>dep&oacute;sito</h6>
        <div className="icon-container">
          <img
            src={banco}
            alt="Icono de un banco"
            srcSet={banco + " 1x, " + banco2x + " 2x"}
          />
        </div>
        <p className="parrafoEnMedioDePago">
          Pag&aacute; tu viaje mediante un deposito y/o transferencia bancaria.
        </p>
        <p>elegir m&eacute;todo</p>
        {!esNacional && codigoMoneda === "PES" && <TextoLeyPais />}
      </div>
    </li>
  );
};

export default CuadroDeposito;



// WEBPACK FOOTER //
// ./src/components/ProcesoCompra/Pago/cuadroDeposito.js